import Ajax from '../../../../util/ajax';
export function zigbeeAddGroup(nid, eid, payload) {
    return (dispatch) => {
        const ajax = new Ajax(dispatch, true);
        const url = '/zigbee/' + nid + '/ep/' + eid + '/cluster/4/command/add-group';
        const value = {
            'group id': payload.groupId,
            'group name': payload.groupName
        };
        ajax.post(url, value);
    };
}
